import {Person} from '../model/person.model'

export const sortByFirstName = (a: Person, b: Person): number => {
	if (!a?.first_name || !b?.first_name) {
		return 0
	}
	if (a.first_name < b.first_name) {
		return -1
	}
	if (a.first_name > b.first_name) {
		return 1
	}
	return 0
}